import { atom } from 'jotai';

/**
 * True once the server is known to be serving a newer build than the one this
 * tab is running. Drives the reload prompt; never reset once set, since the only
 * way out is a reload.
 */
export const newVersionAvailableAtom = atom<boolean>(false);
